import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import genericHelpers from '../_utils/generic-helpers';
import DecapitalisedTitle from '../_utils/decapitalised-title';
// -----------------------------------------------------------
//  MobileSortOption
// -----------------------------------------------------------

const MobileSortOption = ({value, title, onChange, selected}) => {
  const [selectedState, setSelectedState] = useState(false);

  useEffect(() => {
    setSelectedState(selected);
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    onChange(value);
  };

  return (
    <li className='options-list-names'>
      <div
      className={classNames(
        'fancy-checkbox-button d-flex',
        'text-unstyled',
        {
          selected: selected,
        }
      )}>
        <input type="radio"
          id={title}
          name='sort'
          className={classNames(
            'mr-2',
            {
              selected: selected,
            }
          )}
          onChange={handleClick}
          value={value}
          checked={selected}
          aria-label={title}/>
        <label htmlFor={title} className='m-0'>
          {title}
        </label>
      </div>
    </li>
  );
};

export default MobileSortOption;
